import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UserAuth } from '../../../context/AuthContext';
import { useTheme  } from '../../../context/ThemeContext';
import { AlertCircle, CheckCircle2, ArrowRight, Package, Zap, Crown, Loader } from 'lucide-react';
import Header from '../../header';
import expertLight from '../../../images/expertLight.png';
import freeLight from '../../../images/freeLight.png';
import sabioLight from '../../../images/sabioLight.png';
import expertDark from '../../../images/expertDark.png';
import freeDark from '../../../images/freeDark.png';
import sabioDark from '../../../images/sabioDark.png';
import logom from '../../../images/logoMain.png';
import logomda from '../../../images/logoMain-D.png';
import './NewComponent.css';

const NewComponent = () => {
  const { token, user } = UserAuth();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const { isDarkMode, themeClass, toggleTheme } = useTheme();

  const LoadingState = () => (
    <div className="loading-banner">
      <Loader className="loading-icon animate-spin" />
      <p>Cargando información de suscripción...</p>
    </div>
  );
  
  const plans = [
    {
      id: 'test',
      name: 'Plan Gratuito',
      price: 'Q0.00',
      colorClass: 'plan-blue',
      iconColorClass: 'icon-red',
      iconLight: freeLight,
      iconDark: freeDark,
      description: 'Ideal para conocer nuestros servicios',
      features: [
        'Acceso a búsquedas básicas',
        'limite de 5 preguntas diarias'
      ]
    },
    {
      id: 'experto',
      name: 'Plan Experto',
      price: 'Q29.99',
      colorClass: 'plan-purple',
      iconColorClass: 'icon-yellow',
      iconLight: expertLight,
      iconDark: expertDark,
      description: 'Características mejoradas para profesionales',
      features: [
        'Preguntas ilímitadas',
        'Generación de diagramas',
        'Guardar preguntas',
        'Análisis intermedio',
        'Contexto limitado de artículos',
        'Acceso a nuevos features',
      ],
      popular: true
    },
    {
      id: 'sabio',
      name: 'Plan Sabio',
      price: 'Q79.99',
      colorClass: 'plan-green',
      iconColorClass: 'icon-blue',
      iconLight: sabioLight,
      iconDark: sabioDark,
      description: 'Máximas capacidades para expertos',
      features: [
        'Preguntas ilímitadas',
        'Generación de diagramas',
        'Guardar preguntas',
        'Análisis profundo',
        'Ingresa textos más largos',
        'Contexto de artículos extenso',
        'Hasta 6 veces más extenso que el nivel Experto',
        'Acceso a publicaciones del Diario Oficial',
        'Acceso a nuevas funcionalidades y actualizaciones',
        'Soporte 24/7'
      ]
    }
  ];

  const checkSubscriptionStatus = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL_PASARELA}/api/recurrente/sub_status`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSubscriptionData(data);
      } else {
        alert(response.error || 'Tu sesión expiro, inicia sesión de nuevo');
        setError('No se pudo obtener el estado de la suscripción');
      }
    } catch (error) {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSubscription = async () => {
    if (!window.confirm('¿Estás seguro de que deseas cancelar tu suscripción?')) return;
    
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL_PASARELA}/api/recurrente/cancel_sub`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        await checkSubscriptionStatus();
      } else {
        setError('No se pudo cancelar la suscripción');
      }
    } catch (error) {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  const initiateCheckout = async (planId) => {
    if (subscriptionData?.subscription?.isActive) {
      alert('Para cambiar de plan, primero debes cancelar tu suscripción actual.');
      return;
    }

    setLoading(true);
    setSelectedPlan(planId);
    setError(null);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL_PASARELA}/api/recurrente/nuevocliente?desired_plan=${planId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          setError('Respuesta de checkout inválida');
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'No se pudo crear el checkout');
      }
    } catch (error) {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSubscriptionStatus();
  }, [token]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  useEffect(() => {
  }, [user, token]);


  return (
    <div className={`subscription-container ${themeClass}`}>
      <div className={`header-chat plan ${themeClass}`}>
              <Header 
               
              />
              |
              {/* Toggle de Tema */}
                <div className="theme-toggle small-toggle">
                  <span className="colorIconToggle">☼</span>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={isDarkMode}
                      onChange={toggleTheme}
                      className="toggle-input"
                    />
                    <span className={`toggle-slider ${themeClass}`}>
                      <span className={`toggle-knob ${themeClass}`} />
                    </span>
                  </label>
                  <span className="colorIconToggle">☽</span>
                </div>
      </div>
      <Link to='/account' className={`back-button backplans ${themeClass}`}>
          ⟨ &nbsp;&nbsp; Regresar
      </Link>
      {loading && <LoadingState />}
      {error && (
        <div className="error-banner">
          <AlertCircle className="error-icon" />
          <p>{error}</p>
        </div>
      )}

      {subscriptionData?.subscription?.isActive && (
        <div className={`current-plan-banner ${themeClass}`}>
          <div className="banner-content">
            <CheckCircle2 className="success-icon" />
            <div className="banner-text">
              <h3>Plan Actual: {subscriptionData.subscription.plan}</h3>
              <p>Próxima facturación: {formatDate(subscriptionData.billing.nextBillingDate)}</p>
            </div>
            <button onClick={handleCancelSubscription} className="cancel-subscription-btn">
              Cancelar Suscripción
            </button>
          </div>
        </div>
      )}

      <div className={`plans-section ${themeClass}`}>
        <div className={`section-header ${themeClass}`}>
          <h2>Nuestros Planes</h2>
          <p>Elige el plan que mejor se adapte a tus necesidades</p>
        </div>

        <div className="plans-grid">
          {plans.map((plan) => (
            <div 
              key={plan.id} 
              className={`plan-card ${plan.colorClass} ${plan.popular ? 'popular' : ''} ${themeClass}`}
            >
              {plan.popular && <div className="popular-tag">Más Popular</div>}
              <div className={`plan-header ${themeClass}`}>
                <img 
                  src={isDarkMode ? plan.iconDark : plan.iconLight} 
                  alt={`${plan.name} icon`}
                  className="plan-icon"
                />
                <h3>{plan.name}</h3>
                <p className={`plan-price ${themeClass}`}>{plan.price}<span className={`plan-price-month ${themeClass}`}>/mes</span></p>
                <p className={`plan-description ${themeClass}`}>{plan.description}</p>
                <div className={`linePlan ${themeClass}`} />
              </div>
              
              <ul className={`feature-list ${themeClass}`}>
                {plan.features.map((feature, index) => (
                  <li key={index}>
                    <CheckCircle2 className={`feature-icon ${plan.iconColorClass} ${themeClass}`} />
                    {feature}
                  </li>
                ))}
              </ul>

              {plan.id !== 'test' && (
                <button
                  onClick={() => initiateCheckout(plan.id)}
                  disabled={loading && selectedPlan === plan.id}
                  className="select-plan-button"
                >
                  {loading && selectedPlan === plan.id ? (
                    'Procesando...'
                  ) : (
                    <>
                      Seleccionar Plan
                      <ArrowRight className="button-icon" />
                    </>
                  )}
                </button>
              )}
            </div>
          ))}
        </div>
        <div className='logopie'>
          <img src={isDarkMode ? logomda : logom} 
              alt="Temis Logo" 
              className="imgTemispie"
            />
        </div>

      </div>

      {/* 
      {subscriptionData && (
        <div className="user-section">
          <div className="user-profile">
            <img
              src={subscriptionData.user.picture || '/default-avatar.png'}
              alt="Profile"
              className="profile-picture"
            />
            <div className={`user-info ${themeClass}`}>
              <h3>{subscriptionData.user.name}</h3>
              <p>{subscriptionData.user.email}</p>
            </div>
          </div>
        </div>
      )}
      */}
    </div>
  );
};

export default NewComponent;